<template>
  <div>
    <v-app-bar
      app
      color="accent-4"
      elevation="1"
      dense
      dark
      clipped-left
    >
      <v-toolbar-title>
        <img class="mt-2" src="@/assets/images/rankdone.svg" alt="" width="150" height="30">
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            x-large
            v-on="on"
          >
            <v-avatar
              color="purple"
              size="28"
            >
              <span class="white--text">R</span>
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logoff">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      app
      permanent
      expand-on-hover
      clipped
    >
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-avatar
              color="purple"
              size="28"
            >
              <span class="white--text">R</span>
            </v-avatar>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              Rankdone user
            </v-list-item-title>
            <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-group prepend-icon="mdi-shield-lock" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Administração</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item :to="{ name: 'AdminNotifications' }">
            <v-list-item-title>
              <v-icon>mdi-bell</v-icon>
              Notificações
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-container>
      <router-view/>
    </v-container>
  </div>
</template>

<script>
import AuthService from '../../services/auth/auth.service';

const authService = new AuthService();
const decoded = authService.getDecoded();

export default {
  name: 'Admin',
  data: () => ({
    userEmail: decoded.email,
  }),
  mounted() {
  },
  methods: {
    logoff() {
      authService.logoff();
      this.$router.push('/login');
    },
  },
};
</script>

<style>

</style>
